import { render, staticRenderFns } from "./ResourceAvailabilityAccordion.vue?vue&type=template&id=94d86584&"
import script from "./ResourceAvailabilityAccordion.vue?vue&type=script&lang=js&"
export * from "./ResourceAvailabilityAccordion.vue?vue&type=script&lang=js&"
import style0 from "./ResourceAvailabilityAccordion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports